import { useEffect } from "react";
import useQueryString from "../../../hook/use-query-string";
import { Link } from "react-router-dom";
import { URL } from "../../../../routers/constants";
import TabGeneral from "./tab-general";
import TabGrowtools from "./tab-growthtools";
import TabNotifications from "./tab-notifications";
import TabCustomFields from "./tab-custom-fields";
import TabTag from "./tab-tag";
import TabLogs from "./tab-logs";

const TAB = {
   GENERAL: 'general',
   GROWTHTOOLS: 'growthtools',
   NOTIFICATIONS: 'notifications',
   CUSTOMFIELDS: 'customFields',
   LOGS: 'logs',
   TAG: 'tag',
}

const General = () => {
   const query = useQueryString();
   const getTab = () => {
      switch (query.tab) {
         case TAB.GENERAL:
            return <TabGeneral />
         case TAB.GROWTHTOOLS:
            return <TabGrowtools />
         case TAB.NOTIFICATIONS:
            return <TabNotifications />
         case TAB.CUSTOMFIELDS:
            return <TabCustomFields />
         case TAB.TAG:
            return <TabTag />
         case TAB.LOGS:
            return <TabLogs />
         default:
            return <TabGeneral />
      }
   }
   return (
      <div id="bot-scene-container" className="">
         <div id="bot-scene-content" className="scroll-light">
            <div className="app-v2-header-wrapper">
               <div className="app-v2-header-left">
                  <span className="app-v2-header-title">
                     Cấu hình chatbot
                  </span>
               </div>
            </div>
            <div className="app-v2-layout-content screen-setting" style={{ background: 'white' }}>
               <div className="col-sm-12 mb20">
                  <div className="tabs-header-container">
                     <div className="wrap-item">
                        <Link to={{
                           pathname: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
                           search: `?tab=${TAB.GENERAL}`,
                        }}>
                           <div className={`tabs-header-item ${(TAB.GENERAL === query.tab || query.tab === undefined) && "active"}`}>
                              <div className="tab-item-title">Cấu hình chung</div>
                           </div>
                        </Link>
                        {/* <Link to={{
                           pathname: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
                           search: `?tab=${TAB.GROWTHTOOLS}`,
                        }}>
                           <div className={`tabs-header-item ${TAB.GROWTHTOOLS === query.tab && "active"}`}>
                              <div className="tab-item-title">Công cụ</div>
                           </div>
                        </Link>
                        <Link to={{
                           pathname: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
                           search: `?tab=${TAB.NOTIFICATIONS}`,
                        }}>
                           <div className={`tabs-header-item ${TAB.NOTIFICATIONS === query.tab && "active"}`}>
                              <div className="tab-item-title">Thông báo</div>
                           </div>
                        </Link>
                        <Link to={{
                           pathname: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
                           search: `?tab=${TAB.CUSTOMFIELDS}`,
                        }}>
                           <div className={`tabs-header-item ${TAB.CUSTOMFIELDS === query.tab && "active"}`}>
                              <div className="tab-item-title">Custom Field</div>
                           </div>
                        </Link>
                        <Link to={{
                           pathname: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
                           search: `?tab=${TAB.TAG}`,
                        }}>
                           <div className={`tabs-header-item ${TAB.TAG === query.tab && "active"}`}>
                              <div className="tab-item-title">Tag</div>
                           </div>
                        </Link>
                        <Link to={{
                           pathname: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
                           search: `?tab=${TAB.LOGS}`,
                        }}>
                           <div className={`tabs-header-item ${TAB.LOGS === query.tab && "active"}`}>
                              <div className="tab-item-title">Logs</div>
                           </div>
                        </Link> */}
                     </div>
                  </div>
                  <div>
                     {getTab()}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default General;